import $ from 'jquery'

/**
 * 底部热门链接切换
 * @param {*} container 
 */
const tabChange = (container) => {

    let index = 0,
        tabTriggle = container.find('.tab-item'),
        tabTarget = container.find('.item-content');

    tabTriggle.on('mouseenter', function () {

        index = $(this).index();
        $(this).addClass('active').siblings().removeClass('active');
        tabTarget.eq(index).removeClass('Hide').siblings().addClass('Hide');

    });

}

export default {
    init: (config) => {

        tabChange(config.container);

    }
}



// WEBPACK FOOTER //
// ./modules/footer-index/js/footer.js